/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_view_more_in_library_button27 = /** @type {(inputs: {}) => string} */ () => {
	return `Join the community and share on the Library`
};

const fr_home_view_more_in_library_button27 = /** @type {(inputs: {}) => string} */ () => {
	return `Envie de contribuer ? Rejoignez la communauté et partagez sur la Bibliothèque`
};

const de_home_view_more_in_library_button27 = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr in der Bibliothek ansehen`
};

const es_home_view_more_in_library_button27 = /** @type {(inputs: {}) => string} */ () => {
	return `Ver más en la Biblioteca`
};

const it_home_view_more_in_library_button27 = /** @type {(inputs: {}) => string} */ () => {
	return `Visualizza altro nella Biblioteca`
};

const ar_home_view_more_in_library_button27 = /** @type {(inputs: {}) => string} */ () => {
	return `شاهد المزيد في المكتبة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_view_more_in_library_button27 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_view_more_in_library_button27(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_view_more_in_library_button27", locale)
	if (locale === "en") return en_home_view_more_in_library_button27(inputs)
	if (locale === "fr") return fr_home_view_more_in_library_button27(inputs)
	if (locale === "de") return de_home_view_more_in_library_button27(inputs)
	if (locale === "es") return es_home_view_more_in_library_button27(inputs)
	if (locale === "it") return it_home_view_more_in_library_button27(inputs)
	return ar_home_view_more_in_library_button27(inputs)
};
export { home_view_more_in_library_button27 as "HOME_VIEW_MORE_IN_LIBRARY_BUTTON" }